import React from "react";
import PropTypes from "prop-types";
import { CBreadcrumb, CBreadcrumbItem } from "@coreui/react";
import { useTranslationContext } from "@/context/TranslationContext";
/**
 * @name AppBreadcrumb
 * @description A component that renders a breadcrumb navigation, displaying the current navigation path with links. It includes the "Dashboard" as the first item and dynamic breadcrumb items based on the passed props.
 * @param {Array} breadcrumbs - An array of breadcrumb objects, each containing the `name`, `pathname`, and an optional `active` property.
 * @returns {JSX.Element} The rendered breadcrumb navigation component.
 */
const AppBreadcrumb = ({ breadcrumbs = [] }) => {
  const t = useTranslationContext();
  
  return (
    <CBreadcrumb className="my-0">
      {breadcrumbs &&
        breadcrumbs.map((breadcrumb, index) => {
          return (
            <CBreadcrumbItem
              {...(breadcrumb.active
                ? { active: true }
                : { href: breadcrumb.pathname })}
              key={index}
            >
              {typeof breadcrumb.name === 'string' ? t(breadcrumb.name) : breadcrumb.name}
            </CBreadcrumbItem>
          );
        })}
    </CBreadcrumb>
  );
};

/**
 * @name propTypes
 * @description Defines the expected prop types for the AppBreadcrumb component.
 * @param {Array} breadcrumbs - The breadcrumbs array should contain objects with properties `name`, `pathname`, and optionally `active`.
 */
AppBreadcrumb.propTypes = {
  breadcrumbs: PropTypes.arrayOf(PropTypes.any),
};

export default React.memo(AppBreadcrumb);
